const moreInfoText = {
  Calls:
    'אחרי שחבילת הדקות מסתיימת, כל דקת שיחה מעבר לחבילה תחויב בתשלום נוסף בהתאם לתנאי התוכנית שלך. ממליצים לך להרחיב את חבילת הדקות ולהמשיך לדבר בראש שקט.',
  InternationalCalls:
    'אחרי שחבילת הדקות מהארץ לחו"ל מסתיימת, כל דקת שיחה ליעדים הכלולים בחבילה תחויב בתשלום נוסף בהתאם לתנאי התוכנית שלך. ממליצים לך להרחיב את חבילת הדקות מהארץ לחו"ל ליעדים המתאימים לך ולהמשיך לדבר בראש שקט.',
  Sms: 'אחרי שחבילת ההודעות מסתיימת, כל הודעה מעבר לחבילה תחויב בתשלום נוסף בהתאם לתנאי התוכנית שלך.',
};
export const UsageTypes = {
  Calls: 'Calls',
  Data: 'Data',
  InternationalCalls: 'InternationalCalls',
  Sms: 'Sms',
};

export const UsageDetails: {
  [key: string]: {
    name: string;
    moreInfoText: string;
    displayExtendedLink: boolean;
    measureUnit?: string;
    icon?: string;
    btnText?: string;
  };
} = {
  Data: {
    name: 'גלישה',
    moreInfoText: '',
    displayExtendedLink: true,
    btnText: 'הרחבת גלישה',
    measureUnit: `GB`,
  },
  Calls: {
    name: 'שיחות',
    moreInfoText: moreInfoText.Calls,
    displayExtendedLink: true,
    measureUnit: `דק'`,
    icon: require('../../images/phone.svg'),
    btnText: 'הרחבת דקות',
  },
  InternationalCalls: {
    name: 'שיחות לחו"ל',
    moreInfoText: moreInfoText.InternationalCalls,
    displayExtendedLink: true,
    measureUnit: `דק'`,
    icon: require('../../images/phone.svg'),
    btnText: 'הרחבת דקות',
  },
  Sms: {
    name: 'הודעות',
    moreInfoText: moreInfoText.Sms,
    displayExtendedLink: false,
    measureUnit: `sms`,
    icon: require('../../images/message.svg'),
  },
};
